import * as React from "react";
import { forwardRef } from "react";
const SvgIconTick = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 13, viewBox: "0 0 19 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.2203 10.2565L1.9531 6.21402L0.5 7.58091L6.2203 13L18.5 1.36689L17.0571 0L6.2203 10.2565Z", fill: "#33D27E" }));
const ForwardRef = forwardRef(SvgIconTick);
export default ForwardRef;
